/**
 * 一定時間経過でポップアップ起動
 */
import React from "react";
import { createRoot } from "react-dom/client";
import Axios from "axios";
import { DateTime } from "luxon";
import "@/shared/global";
import Popup from "@/shared/components/popup";
import Cookie, { COOKIE_KEY_USER, COOKIE_ADMIN_TYPE } from "@/shared/cookie";
import { LSKEY_POPUP } from "@/shared/constants/localstorage";
import route from "@/shared/ziggy/route";

const timeout = 1000; // タイムアウト監視感覚(ms)
let countDown = 7000; // ポップアップが表示されるまでの時間(ms)

/**
 * APIアクセス
 *
 * @returns Promise
 * @param pageType
 */
const api = (pageType) => {
  const endpoint = route("api.user.popup", { pageType });
  return Axios.get(endpoint);
};

/**
 * 一定期間再表示停止の判定
 *
 * @param {int} id
 * @returns {boolean}
 */
const isNotDisplay = (id) => {
  const expiry = DateTime.fromISO(localStorage.getItem(LSKEY_POPUP(id))); // 有効期限
  const now = DateTime.utc();

  return expiry > now; // 有効期限が現在時刻より未来の場合は表示しない
};

/**
 * 再登場待ちさせる時刻を設定
 * @param {int} id
 */
const breakTime = (id) => {
  localStorage.setItem(
    LSKEY_POPUP(id),
    DateTime.utc().plus({ days: 1 }).toString(),
  );
};

/**
 * タイマー処理
 */
const timer = (el) => {
  // 別のモーダルが開いていたらカウントダウンなどはスルー
  if (!window.St.modal) {
    countDown -= timeout;

    if (countDown < 0) {
      api(el.dataset.page_type).then(({ data }) => {
        if (!data || isNotDisplay(data.popup_id)) {
          return;
        }

        breakTime(data.popup_id);
        const root = createRoot(el);

        root.render(
          <Popup
            id="popup"
            tracking={Cookie.get(COOKIE_KEY_USER)}
            adminType={Cookie.get(COOKIE_ADMIN_TYPE)}
            requestIp={el.dataset.requestIp}
            {...data}
          />,
        );
      });

      return;
    }
  }

  setTimeout(timer, timeout, el);
};

window.addEventListener("load", () => {
  const el = document.getElementById("popup");

  if (el) {
    timer(el);
  }
});
